import module from 'kendu/legacy/module'
import { forEach } from 'lodash'

function $kdStyles ($cacheFactory) {
  let StyleSheetCache = $cacheFactory('kdStyleSheets')

  this.media = media

  function media (mediaQuery) {
    return getStyleSheet(mediaQuery || '')
  }

  function getStyleSheet (mediaQuery) {
    let CSSStyleSheet = StyleSheetCache.get(mediaQuery)

    if (CSSStyleSheet) return CSSStyleSheet

    CSSStyleSheet = createStyleSheet(mediaQuery)

    StyleSheetCache.put(mediaQuery, CSSStyleSheet)

    return CSSStyleSheet
  }

  function createStyleSheet (mediaQuery) {
    let CSSStyleSheet = {
      media: mediaQuery,
      styleSheet: undefined,
      insertRule: () => {},
    }

    if (!document.styleSheets) return
    if (document.getElementsByTagName('head').length === 0) return

    forEach(document.styleSheets, function (item) {
      if (item.disabled || typeof CSSStyleSheet.styleSheet !== 'undefined') {
        return
      }

      if (typeof item.media === 'string' && item.media === mediaQuery) {
        CSSStyleSheet.styleSheet = item
      } else if (typeof item.media === 'object' && item.media.mediaText === mediaQuery) {
        CSSStyleSheet.styleSheet = item
      }
    })

    if (typeof CSSStyleSheet.styleSheet === 'undefined') {
      let styleSheetElement = document.createElement('style')
      styleSheetElement.type = 'text/css'
      styleSheetElement.media = mediaQuery
      document.getElementsByTagName('head')[0].appendChild(styleSheetElement)

      for (let i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].disabled) continue

        CSSStyleSheet.styleSheet = document.styleSheets[i]
      }
    }

    if (typeof CSSStyleSheet.styleSheet.media === 'string') {
      CSSStyleSheet.insertRule = function (selector, definition) {
        let style = parse(definition)

        for (let i = 0, l = CSSStyleSheet.styleSheet.rules.length; i < l; i++) {
          if (CSSStyleSheet.styleSheet.rules[i].selectorText && CSSStyleSheet.styleSheet.rules[i].selectorText.toLowerCase() === selector.toLowerCase()) {
            CSSStyleSheet.styleSheet.rules[i].style.cssText = style
            return
          }
        }

        CSSStyleSheet.styleSheet.addRule(selector, style)
      }
    } else if (typeof CSSStyleSheet.styleSheet.media === 'object') {
      CSSStyleSheet.insertRule = function (selector, definition) {
        let styleSheetLength = (CSSStyleSheet.styleSheet.cssRules) ? CSSStyleSheet.styleSheet.cssRules.length : 0
        let style = parse(definition)

        for (let i = 0; i < styleSheetLength; i++) {
          if (CSSStyleSheet.styleSheet.cssRules[i].selectorText && CSSStyleSheet.styleSheet.cssRules[i].selectorText.toLowerCase() === selector.toLowerCase()) {
            CSSStyleSheet.styleSheet.cssRules[i].style.cssText = style
            return
          }
        }

        CSSStyleSheet.styleSheet.insertRule(selector + '{' + style + '}', styleSheetLength)
      }
    }

    StyleSheetCache.put(mediaQuery, CSSStyleSheet)

    return CSSStyleSheet
  }

  function parse (style) {
    if (typeof style === 'string') {
      return style
    }

    let cssText = []

    for (let i in style) {
      if (style.hasOwnProperty(i)) {
        cssText.push(i + ':' + style[i])
      }
    }

    return cssText.join(';')
  }
}

module.service('$kdStyles', $kdStyles)



// WEBPACK FOOTER //
// ./src/deprecated/services/$kdStyles.js